import { useSelector } from 'react-redux';
import { selectCatalogSettings } from '@client/settings/redux/redux';
import { SettingsCatalogType } from '@client/settings/redux/types';

export const useCatalogSettingsData = (): SettingsCatalogType => {
  const catalogSettings = useSelector(selectCatalogSettings);

  return {
    viewType: catalogSettings.viewType,
    pageSize: catalogSettings.pageSize,
  };
};
